import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What\'s included in the free Launch plan?",
      answer: "The Launch plan includes access to basic AI-powered prompt generation with up to 50 prompts per month. You\'ll get general prompt suggestions across all categories without the ability to save or organize them."
    },
    {
      question: "Can I upgrade or downgrade my plan anytime?",
      answer: "Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately, and we'll prorate any billing differences. Your saved prompts and settings will be preserved during plan changes."
    },
    {
      question: "What makes the Command tier different?",
      answer: "The Command tier includes custom GPT system prompts, master workflow builder, priority support, and unlimited prompt generation. It's designed for enterprises and power users who need advanced customization and workflow automation."
    },
    {
      question: "Do you offer refunds?",
      answer: "We offer a 14-day money-back guarantee for all paid plans. If you're not satisfied within the first 14 days, we'll provide a full refund, no questions asked."
    },
    {
      question: "Is my data secure?",
      answer: "Absolutely. We use enterprise-grade security with 256-bit SSL encryption, SOC 2 compliance, and GDPR-ready privacy controls. Your prompts and data are never shared with third parties."
    },
    {
      question: "Can I use PitchEngine AI for commercial purposes?",
      answer: "Yes, all plans include commercial usage rights. You can use generated prompts for client work, marketing campaigns, and any business applications without additional licensing fees."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-text-primary mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-text-secondary">
          Everything you need to know about our pricing and features
        </p>
      </div>
      <div className="space-y-4">
        {faqs?.map((faq, index) => (
          <div key={index} className="bg-card rounded-lg border border-border overflow-hidden">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-muted transition-colors"
            >
              <h3 className="font-semibold text-text-primary pr-4">
                {faq?.question}
              </h3>
              <Icon 
                name={openIndex === index ? "ChevronUp" : "ChevronDown"} 
                size={20} 
                color="var(--color-text-secondary)"
                className="flex-shrink-0"
              />
            </button>
            {openIndex === index && (
              <div className="px-6 pb-4">
                <p className="text-text-secondary leading-relaxed">
                  {faq?.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;